import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { persimmon } from './colors';

var isSelectionTruthy = function isSelectionTruthy(value) {
  return !(Array.isArray(value) && !value.length || value === null || value === undefined || value === '');
};

var noop = function noop() {};

var SelectWrapper = function SelectWrapper(props) {
  var value = props.value,
      containerClassName = props.containerClassName,
      placeholder = props.placeholder,
      label = props.label,
      selectedSelect = props.selectedSelect,
      required = props.required,
      helpText = props.helpText,
      onBlurResetsInput = props.onBlurResetsInput,
      _props$onBlur = props.onBlur,
      onBlur = _props$onBlur === void 0 ? noop : _props$onBlur,
      _props$onFocus = props.onFocus,
      onFocus = _props$onFocus === void 0 ? noop : _props$onFocus;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      shouldFloat = _useState2[0],
      setShouldFloat = _useState2[1];

  var handleFocus = function handleFocus() {
    setShouldFloat(true);
    onFocus();
  };

  var handleBlur = function handleBlur(event) {
    var target = event && event.target;

    if (onBlurResetsInput === false && target && target.value || isSelectionTruthy(value)) {
      setShouldFloat(true);
    } else {
      setShouldFloat(false);
    }

    onBlur();
  };

  var handleInputKeyDown = function handleInputKeyDown() {
    setShouldFloat(true);
  };

  useEffect(function () {
    setShouldFloat(isSelectionTruthy(value));
  }, [value]);
  var className = "react-select-wrapper form-group ".concat(shouldFloat ? 'form-group-active' : '', " ").concat(containerClassName || '');
  return React.createElement("div", {
    className: className
  }, React.createElement("label", {
    style: {
      pointerEvents: 'none',
      wordWrap: 'break-word',
      width: '80%'
    },
    className: "control-label"
  }, placeholder || label, required ? React.createElement("span", {
    style: {
      color: persimmon.base
    }
  }, " *") : ''), React.createElement(selectedSelect, _objectSpread({}, props, {
    onFocus: handleFocus,
    onBlur: handleBlur,
    onInputKeyDown: handleInputKeyDown,
    placeholder: ''
  })), helpText ? React.createElement("small", {
    className: "help-block"
  }, helpText) : null);
};

SelectWrapper.propTypes = {
  containerClassName: PropTypes.string,
  required: PropTypes.bool,
  selectedSelect: PropTypes.func,
  label: PropTypes.node,
  placeholder: PropTypes.node,
  value: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  helpText: PropTypes.node,
  onBlurResetsInput: PropTypes.bool
};
export default SelectWrapper;